/**
 * Cross-widget KPI selection.
 *
 * The Variance table sets the active KPI for an asset (by clicking a KPI row);
 * the Consensus Revision chart subscribes and re-plots that KPI. Keyed by the
 * asset's data uid so two assets open at once don't cross-talk. Mirrors the
 * module-level pub/sub used by `widgetRefetchRegistry`.
 */

const selected = new Map<string, string>(); // uid -> kpi
const listeners = new Set<() => void>();

export function setSelectedKpi(uid: string, kpi: string): void {
  selected.set(uid, kpi);
  listeners.forEach((fn) => fn());
}

export function getSelectedKpi(uid: string | undefined): string | undefined {
  return uid ? selected.get(uid) : undefined;
}

/** Clear an asset's selection (e.g. when switching assets) so it starts fresh. */
export function clearSelectedKpi(uid: string | undefined): void {
  if (uid && selected.delete(uid)) listeners.forEach((fn) => fn());
}

export function subscribeKpi(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
